import DOMPurify from 'dompurify';
import parse from 'html-react-parser';
import { Box } from '@chakra-ui/react';
import { useRawTranslation } from 'helpers/languages/translations';

const DescriptionHtml = (props: { tradKey?: string; text?: string } & Record<string, any>) => {
    const translate = useRawTranslation();

    const { tradKey, text, ...otherProps } = props;
    const rawHtml = tradKey ? translate(tradKey) : text || '';

    return (
        <Box {...otherProps} className="textbox">
            {parse(DOMPurify.sanitize(rawHtml))}
        </Box>
    );
};

export default DescriptionHtml;
